import React, {Suspense, useEffect} from "react";
import isEmpty from "is-empty";
import classNames from "classnames";
import useWithStore from "@/Hooks/useWithStore";
import useViewItemBatcher from "@/Hooks/useViewItemBatcher";
import {lazyWithPreload} from "@/Helpers/lazyWithPreload";
import LazySection from "@/Components/LazySection";
import BaseLayout from "@/Layouts/BaseLayout";
import Breadcrumbs from "@/pages/Site/Catalog/Breadcrumbs";
import Picture from "@/Components/Picture";
import {useAllStore} from "@/Stores/useAllStore";
import {CatalogCard} from "@/widgets/catalog-card";
import {CatalogShowMore} from "@/widgets/catalog-show-more";
import {CatalogTags} from "@/widgets/catalog-tags";
import {CatalogFilters} from "@/widgets/catalog-filters";
import "@/Scss/Site/Catalog/index.scss";
import styles from "./ui/Index.module.scss";

// const FilterDrawer = lazy(() => import('@/Components/Drawer/FilterDrawer'));
// const FiltersDrawer = lazy(() => import('@/pages/Site/Catalog/FiltersDrawer'));
const CatalogFilterDrawer = lazyWithPreload(() =>
    import('@/widgets/catalog-filter-drawer').then(module => ({
        default: module.CatalogFilterDrawer,
    })),
);
const CatalogFiltersDrawer = lazyWithPreload(() =>
    import('@/widgets/catalog-filters-drawer').then(module => ({
        default: module.CatalogFiltersDrawer,
    })),
);
const Pagination = lazyWithPreload(() =>
    import('@/shared/ui/Pagination').then(module => ({
        default: module.Pagination,
    })),
);

const Index = (props) => {
    const {
        h1 = '',
        stores = {},
        images = {},
        products = [],
        isMobile = false,
        count = 0,
        seoText = '',
        tagOne = [],
        filters = [],
        dataSort = [],
        insertColors = [],
        isDesktop = false,
        selectedFilters = []
    } = props;
    const {catalogStore = {}} = stores;

    const sectionClasses = classNames(styles.section, {[styles.offset]: !isEmpty(images)});

    const {registerView} = useViewItemBatcher();

    useEffect(() => {
        catalogStore.start(props);
    }, [products]);

    useEffect(() => {
        catalogStore.startFilters(props);
    }, []);

    return (
        <BaseLayout {...props}>
            <section className={sectionClasses}>
                {!isEmpty(images) && (
                    <div className={styles.catalogImage}>
                        <Picture src={images.img_path} srcMobile={images.img_mobile_path} alt={h1} />
                    </div>
                )}
                <div className={`globalContainer`}>
                    <Breadcrumbs {...props} />
                    <div className={styles.catalog}>
                        <div className={styles.titleContainer}>
                            <h1 className={styles.title}>{h1}</h1>
                            {count !== 0 && (
                                <p className={styles.count}>
                                    | Найдено {count.toLocaleString('ru')}
                                </p>
                            )}
                        </div>
                        <div className={styles.inner}>
                            <CatalogFilters
                                filters={filters}
                                dataSort={dataSort}
                                insertColors={insertColors}
                                isDesktop={isDesktop}
                                selectedFilters={selectedFilters}
                            />
                            <div className={styles.catalogCards}>
                                {count !== 0 ?
                                    <>
                                        {products.map((product, i) => {
                                            return (
                                                <CatalogCard
                                                    key={product.id}
                                                    product={product}
                                                    mediaVariant={`slider`}
                                                    // variant={`withShadow`}
                                                    className={styles.card}
                                                    index={(catalogStore.page - 1) * catalogStore.perPageStart + i + 1}
                                                    registerView={registerView}
                                                />
                                            );
                                        })}
                                    </>
                                    :
                                    <>
                                        Не удалось найти украшения с указанными параметрами. Попробуйте сбросить
                                        фильтры.
                                    </>
                                }
                            </div>
                            {count > catalogStore.perPageStart && (
                                <div className={styles.paginationContainer}>
                                    <CatalogShowMore />
                                    <LazySection>
                                        <Pagination
                                            activePage={catalogStore.activePage}
                                            totalItemsCount={count}
                                            pageRangeDisplayed={isMobile ? 4 : 10}
                                            itemsCountPerPage={catalogStore.perPageStart}
                                            onChange={catalogStore.handlePageChange}
                                            hideFirstLastPages={isMobile}
                                        />
                                    </LazySection>
                                    {/*<LazySection>*/}
                                    {/*    <Pagination*/}
                                    {/*        activePage={catalogStore.activePage}*/}
                                    {/*        itemsCountPerPage={catalogStore.perPageStart}*/}
                                    {/*        totalItemsCount={count}*/}
                                    {/*        pageRangeDisplayed={isMobile ? 4 : 10}*/}
                                    {/*        onChange={catalogStore.handlePageChange}*/}
                                    {/*        hideFirstLastPages={isMobile}*/}
                                    {/*    />*/}
                                    {/*</LazySection>*/}
                                </div>
                            )}
                            {(seoText !== '') && (<p className={styles.seoText}>{seoText}</p>)}
                            <CatalogTags tags={tagOne} />
                        </div>
                    </div>
                </div>
            </section>
            <Modals {...props} />
        </BaseLayout>
    )
}

// const ShowMore = observer((props) => {
//     const {stores = {}, count = 0} = props;
//     const {catalogStore = {}} = stores;
//
//     if (catalogStore.activePage >= Math.ceil(count / catalogStore.perPageStart)) return null;
//
//     return (
//         <div className={`showMore`}>
//             <div
//                 onClick={catalogStore.showMore}
//                 className={`button button--white${catalogStore.loaderShowBtn ? " load" : ""}`}
//             >
//                 Показать еще
//             </div>
//         </div>
//     );
// });

const Modals = (props) => {
    const interactionFlag = useAllStore((state) => state.interactionFlag);

    if (!interactionFlag) return null;

    return (
        <>
            {/*<Suspense><FilterDrawer {...props} /></Suspense>*/}
            {/*<Suspense><FiltersDrawer {...props} /></Suspense>*/}
            <Suspense><CatalogFilterDrawer /></Suspense>
            <Suspense><CatalogFiltersDrawer /></Suspense>
        </>
    );
};

export default useWithStore(Index);
